import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { IoDiamondOutline, IoMapOutline, IoColorWandOutline, IoPulseOutline, IoArrowForward } from 'react-icons/io5';
import './CustomizedTours.css';

const customFeatures = [
  {
    id: 1,
    icon: <IoMapOutline />,
    title: "Bespoke Itineraries",
    desc: "We don't just book trips; we craft stories. Every route is mapped to your personal interests.",
  },
  {
    id: 2,
    icon: <IoDiamondOutline />,
    title: "Luxury Concierge",
    desc: "From private jets to hidden villas, our elite network ensures you travel like royalty.",
  },
  {
    id: 3,
    icon: <IoColorWandOutline />,
    title: "Unique Experiences",
    desc: "Cooking with local chefs or private island dinners—we make the impossible, possible.",
  },
  {
    id: 4,
    icon: <IoPulseOutline />,
    title: "24/7 Expert Care",
    desc: "Our travel designers are always a call away, ensuring a seamless and safe journey.",
  }
];

const CustomizedTours = () => {
  const navigate = useNavigate();

  return (
    <section id="customized-tours" className="ct-premium-section">
      <div className="ct-wrapper">
        
        {/* --- Updated Heading Section (Matching Adventure/Domestic) --- */}
        <div className="center-header">
          <motion.span 
            initial={{ opacity: 0, letterSpacing: "0px" }}
            whileInView={{ opacity: 1, letterSpacing: "4px" }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false }}
            className="header-tag"
            style={{ display: 'block', marginBottom: '10px' }}
          >
            CHANDRAMA EXCLUSIVE
          </motion.span>

          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: false }}
            className="header-title"
          >
            Craft Your <span>Personalized</span> Journey
          </motion.h2>

          <motion.div 
            initial={{ width: 0 }}
            whileInView={{ width: "80px" }}
            transition={{ duration: 1, delay: 0.4 }}
            viewport={{ once: false }}
            className="title-line"
          ></motion.div>
        </div>

        <div className="ct-cards-grid">
          {customFeatures.map((item, index) => (
            <motion.div 
              key={item.id}
              className="ct-luxury-card"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: false }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -12 }}
            >
              <div className="ct-card-icon-box">{item.icon}</div>
              <div className="ct-card-content">
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
              <div className="ct-card-glow"></div>
            </motion.div>
          ))}
        </div>

        {/* Action Area */}
        <motion.div 
          className="ct-action-area"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
        >
    

 
    <button
      className="ct-redirect-btn"
      onClick={() => navigate('/contact')}
    >
      Plan My Trip <IoArrowForward />
    </button>
  



          <p className="ct-help-text">Speak with our travel designers for a bespoke itinerary</p>
        </motion.div>

      </div>
    </section>
  );
};

export default CustomizedTours;